import { configureStore } from "@reduxjs/toolkit";
import configSlice from "./slice/configSlice";
import userSlice from "./slice/userSlice";
import groupSlice from "./slice/groupSlice";
import referrerSlice from "./slice/referrerSlice";
import applicationSlice from "./slice/applicationSlice";
import moduleFilterSlice from "./slice/moduleFilter";
import assignedSlice from "./slice/assignedSlice";
import searchSlice from "./slice/searchSlice";
import filterOptions from "./slice/filterOptions";

export const store = configureStore({
  reducer: {
    configSlice,
    userSlice,
    groupSlice,
    referrerSlice,
    applicationSlice,
    moduleFilterSlice,
    assignedSlice,
    searchSlice,
    filterOptions
  },
});
